import { Tab, TabList, TabPanel, Tabs, Text } from "@hopper-ui/components";
import { Outlet, useLocation } from "react-router";
import { usePaths } from "#paths.ts";
import { ASSESSMENT_TABS } from "./assessmentTabs.ts";

export function AssessmentNavbar() {
    const paths = usePaths();
    const { pathname } = useLocation();

    return (
        <Tabs aria-label="Migration project tabs" selectedKey={pathname}>
            <TabList>
                {ASSESSMENT_TABS.map(({ pathKey, label, icon: Icon, iconSize }) => {
                    const href = paths[pathKey];

                    return (
                        <Tab key={pathKey} id={href} aria-label={label} href={href}>
                            <Text data-public>{label}</Text>
                            {Icon && <Icon size={iconSize} />}
                        </Tab>
                    );
                })}
            </TabList>
            <TabPanel id={pathname} paddingTop="inset-lg">
                <Outlet />
            </TabPanel>
        </Tabs>
    );
}
